export class Const {

  protected static SM_URL_PROD = 'https://mysamsungv3.overmob.com';
  protected static SM_URL_STAGE = 'https://mysamsungv3stage.overmob.com';

  protected static PR_LOGIN_URL_STAGE = 'https://op-samsungpeople.e-gatesviluppo.net:450/LoginOverMob.aspx';
  protected static PR_LOGIN_URL_PROD = 'https://promozioni.samsung.it/LoginOvermob';

}
